export default class DisplayToggle {
    constructor() {
        this.produits = window.produitsData || [];
        this.currentIndex = 0;

        // éléments dynamiques (peuvent être null)
        this.eyebrow = document.querySelector('h2.seo-eyebrow');
        this.title = document.querySelector('div.seo-h2 .title-js');
        this.subtitle = document.querySelector('p.seo-h6.title-js');
        this.textContainer = document.querySelector('.text-js');
        this.linkEls = document.querySelectorAll('.lien-js');
        this.imageEl = document.querySelector('.image-js');
        this.counter = document.querySelector('.counter-js');

        // lancer init seulement si les éléments existent
        if (this.title && this.subtitle && this.textContainer && this.imageEl && this.linkEls.length > 0) {
            this.init();
        }
    }

    init() {
        const left = document.querySelector('.angle-left');
        const right = document.querySelector('.angle-right');

        if (left) left.addEventListener('click', () => this.prev());
        if (right) right.addEventListener('click', () => this.next());

        this.setMaxHeight();

        [this.title, this.subtitle, this.textContainer, this.imageEl, ...this.linkEls].forEach(el => {
            if (el) el.classList.add('active');
        });

        this.update();
    }

    setMaxHeight() {
        if (!this.textContainer || this.produits.length === 0) return;

        let maxTextHeight = 0;

        this.produits.forEach(produit => {
            const temp = document.createElement('div');
            temp.style.visibility = 'hidden';
            temp.style.position = 'absolute';
            temp.style.width = this.textContainer.offsetWidth + 'px';
            temp.innerHTML = Array.isArray(produit.desc) ? produit.desc.join('<br>') : produit.desc;
            document.body.appendChild(temp);
            maxTextHeight = Math.max(maxTextHeight, temp.offsetHeight);
            document.body.removeChild(temp);
        });

        this.textContainer.style.height = maxTextHeight + 'px';
    }

    update() {
        if (this.produits.length === 0) return;

        const produit = this.produits[this.currentIndex];

        // fade out
        [this.title, this.subtitle, this.textContainer, this.imageEl, ...this.linkEls].forEach(el => {
            if (el) el.classList.remove('active');
        });

        setTimeout(() => {
            if (this.title) this.title.textContent = produit.title;
            if (this.subtitle) this.subtitle.textContent = produit.title;

            if (this.textContainer) {
                this.textContainer.innerHTML = '';
                const descs = Array.isArray(produit.desc) ? produit.desc : [produit.desc];
                if (descs.length > 0) {
                    const p = document.createElement('p');
                    p.innerHTML = descs.filter(d => d).join('<br><br>');
                    this.textContainer.appendChild(p);
                }
            }

            this.linkEls.forEach(link => {
                if (link) link.href = '/produit/' + produit.link + '/';
            });

            if (this.imageEl) {
                this.imageEl.src = produit.src + '.webp';
                this.imageEl.alt = produit.title;
            }

            if (this.counter) {
                this.counter.textContent = `${this.currentIndex + 1} / ${this.produits.length}`;
            }

            // fade in
            [this.title, this.subtitle, this.textContainer, this.imageEl, ...this.linkEls].forEach(el => {
                if (el) el.classList.add('active');
            });
        }, 300);
    }

    prev() {
        if (this.produits.length === 0) return;
        this.currentIndex = (this.currentIndex - 1 + this.produits.length) % this.produits.length;
        this.update();
    }

    next() {
        if (this.produits.length === 0) return;
        this.currentIndex = (this.currentIndex + 1) % this.produits.length;
        this.update();
    }
}

document.addEventListener('DOMContentLoaded', () => new DisplayToggle());
